var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-breadcrumb',{attrs:{"separator":"/"}},_vm._l((_vm.breadcrumbs),function(item,index){return _c('el-breadcrumb-item',{key:index},[(index === _vm.breadcrumbs.length - 1)?_c('span',[_vm._v(_vm._s(item.meta.title))]):_c('router-link',{attrs:{"to":item.path}},[_vm._v(_vm._s(item.meta.title))])],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }